import { Button } from "@/components/Button";
import { CatalogControl } from "./CatalogControl";

export const CatalogControlGroup = ({
  options,
  value,
  onChange,
  onReset,
}: {
  options: Array<Catalog.Options>;
  value: Record<string, number>;
  onChange?: (event: { name: string; selectedIndex: number }) => void;
  onReset?: () => void;
}) => {
  const dirty =
    Object.values(value).length > 0 &&
    Object.values(value).some((val) => val > 0);
  return (
    <div className="grid sm:grid-cols-3 gap-2">
      {options.map(({ name, labels }, i) => (
        <CatalogControl
          key={i}
          labels={labels}
          selectedIndex={value[name]}
          onChange={(selectedIndex) => onChange?.({ name, selectedIndex })}
        />
      ))}
      {dirty && (
        <Button variant="secondary" onClick={onReset}>
          Filter löschen
        </Button>
      )}
    </div>
  );
};
